import { Row } from 'antd';
import styled from 'styled-components';
import { CssSpace } from '@xbcb/ui-types';

export const StyledRow = styled(Row)`
  padding-bottom: ${CssSpace.SPACE_3};
`;

// Matching style of FormItem
export const Container = styled.div`
  margin-bottom: 16px;
`;
